import { render, staticRenderFns } from "./Therapy_Item.vue?vue&type=template&id=dd7324bc&"
import script from "./Therapy_Item.vue?vue&type=script&lang=js&"
export * from "./Therapy_Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports